<template>
  <div class="menu-title d-flex">
    <div class="name">
      <span>{{ title }}</span>
    </div>
    <div v-if="showPds" class="pds">
      <el-select v-model="pds" size="mini" placeholder="请选择配电室">
        <el-option
          v-for="item in options"
          :key="item.IdStr"
          :label="item.ModelName"
          :value="item.IdStr"
        />
      </el-select>
    </div>

    <!-- 树形数据的位置 -->
    <div v-if="showTree" class="pt-1 d-flex flex-1 tree_data">
      <div
        v-for="(item, i) in treePath"
        :key="i"
        class="tree_data_item d-flex"
        @click="handleNodeClick(item)"
      >
        <i v-if="i !== 0" class="el-icon-arrow-right" style="margin: 0 3px" />
        <span>{{ item.GName }}</span>
      </div>
    </div>

    <slot />
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  props: {
    title: { type: [String], default: '标题' },
    showPds: { type: [Boolean], default: false }
  },
  data() {
    return {
      pds: '',
      options: [],
      // 设备路径
      treePath: []
    }
  },
  computed: {
    ...mapGetters({ selectProject: 'selectProject' }),
    ...mapState({
      treeDta: (state) => state['business/CommonService'].treeDta.Tree,
      showTree: (state) => state['business/CommonService'].showTree,
      selectTreeNode: (state) => state['business/CommonService'].selectTreeNode
    })
  },
  watch: {
    pds() {
      this.$store.dispatch('projects/setSelectPds', this.pds)
    },
    // 当前路径计算
    selectTreeNode: {
      handler(val) {
        if (this.showTree) {
          this.deepLook(val, this.treeDta[0], (res) => {
            this.treePath = res
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    console.log(this.selectProject)
    this.options = this.selectProject.Children
    if (this.options && this.options.length) {
      this.pds = this.options[0].IdStr
    }
  },
  methods: {
    ...mapActions(['GetCommomTree', 'SetSelectTreeNode']),
    handleNodeClick(item) {
      this.SetSelectTreeNode(item)
    },
    // 寻找节点路径
    deepLook(target, treeData, callback = () => {}) {
      var temppath = []
      try {
        var getNodePath = function(node) {
          temppath.push(node)
          // 找到符合条件的节点，通过throw终止掉递归
          if (node.GUID === target.GUID) {
            // eslint-disable-next-line no-throw-literal
            throw 'Got It ! To Callback'
          }
          if (node.Children && node.Children.length > 0) {
            for (var i = 0; i < node.Children.length; i++) {
              getNodePath(node.Children[i])
            }
            temppath.pop()
          } else {
            temppath.pop()
          }
        }
        getNodePath(treeData)
      } catch (e) {
        var result = temppath
        callback(result)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tree_data_item {
  flex-shrink: 0;
  align-items: center;
  cursor: pointer;
}
.tree_data {
  margin-left: 30px;
  overflow: auto;
  flex-shrink: 0;
  flex-shrink: 0;
  scrollbar-width: 0; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
.menu-title {
  .el-select {
    .el-input {
      .el-input__inner {
        background: rgba(0, 0, 0, 0.2);
        color: #ffffff;
        border: 0.5px solid #989898;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.menu-title {
  height: 45px;
  width: 100%;
  padding: 10px;
  background: linear-gradient(to right, #031e36, #063866);
  .name {
    font-size: 18px;
    position: relative;
    &::before {
      content: "";
      width: 2px;
      height: 17px;
      background: #a0eeff;
      position: absolute;
      left: 10px;
      top: 4px;
    }
    span {
      padding-left: 25px;
      line-height: 25px;
      color: #bde4ff;
    }
  }
  .pds {
    padding-left: 40px;
  }
  .breadcrumbs {
    margin-left: 20px;
  }
}
</style>
